import { render, staticRenderFns } from "./SummaryByBiz.vue?vue&type=template&id=78deb834&lang=pug"
import script from "./SummaryByBiz.vue?vue&type=script&lang=js"
export * from "./SummaryByBiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports